import UnderConstructionScreen from "./Screens/UnderConstructionScreen";

const UnderConstruction = () => {
  return <UnderConstructionScreen />;
};

export default UnderConstruction;
